(() => {
 if (window.sideLightsStudioReady) return;
 window.sideLightsStudioReady = true;
 const reduced = matchMedia('(prefers-reduced-motion:reduce)');
 function init(root = document) {
  root.querySelectorAll('[data-sl-motion]').forEach(section => {
   if (section.dataset.slReady) return;
   const videos = [...section.querySelectorAll('video')];
   const button = section.querySelector('[data-sl-toggle]');
   if (!button || !videos.length) return;
   section.dataset.slReady = 'true';
   const states = new Map(), listeners = [];
   let paused = false, explicit = false, disposed = false;
   const stop = () => paused || (!explicit && reduced.matches);
   const wanted = s => !disposed && s.visible && !stop() && !document.hidden;
   const label = () => { button.textContent = stop() || [...states.values()].some(s => s.blocked) ? button.dataset.slPlay : button.dataset.slPause; };
   function listen(target, event, handler) {
    target.addEventListener(event, handler);
    listeners.push(() => target.removeEventListener(event, handler));
   }
   function poster(s, show) { if (s.poster) s.poster.hidden = !show; }
   function cancelFrame(s) {
    if (s.frameId !== null && s.v.cancelVideoFrameCallback) s.v.cancelVideoFrameCallback(s.frameId);
    s.frameId = null;
   }
   function watchFrame(s) {
    if (!s.resilient || !wanted(s) || s.frameId !== null || !s.v.requestVideoFrameCallback) return;
    s.frameId = s.v.requestVideoFrameCallback(() => {
     s.frameId = null;
     if (!wanted(s)) return;
     s.lastProgress = performance.now();
     s.lastTime = s.v.currentTime;
     s.blocked = false;
     if (s.retry) s.retry.hidden = true;
     poster(s, false);
     label();
     watchFrame(s);
    });
   }
   function block(s) {
    s.token++; s.pending = false; s.blocked = true;
    s.v.pause(); cancelFrame(s); poster(s, true);
    if (s.retry) s.retry.hidden = false;
    label();
   }
   function start(s) {
    if (!wanted(s) || s.pending || s.blocked) return;
    watchFrame(s);
    if (!s.v.paused) return;
    s.v.muted = true; s.v.defaultMuted = true; s.v.playsInline = true;
    const token = ++s.token;
    s.pending = true;
    let attempt;
    try { attempt = s.v.play(); } catch (error) { s.pending = false; block(s); return; }
    Promise.resolve(attempt).then(() => {
     if (disposed || token !== s.token) return;
     if (!wanted(s)) s.v.pause();
     watchFrame(s);
    }).catch(error => {
     if (disposed || token !== s.token) return;
     if (error.name !== 'AbortError') block(s);
    }).finally(() => {
     if (token === s.token) s.pending = false;
     if (!disposed) label();
    });
   }
   function reset(s) {
    // Invalidates any unresolved play promise before a new user/automatic attempt.
    s.token++; s.pending = false; s.blocked = false;
    cancelFrame(s); s.v.pause(); poster(s, true);
    s.lastProgress = performance.now(); s.lastTime = -1;
    if (s.retry) s.retry.hidden = true;
    s.v.load();
   }
   function sync() {
    states.forEach(s => {
     const active = wanted(s);
     if (active && !s.active) s.lastProgress = performance.now();
     s.active = active;
     if (active) start(s);
     else { s.token++; s.pending = false; s.v.pause(); cancelFrame(s); }
    });
    label();
   }
   const observer = new IntersectionObserver(entries => {
    entries.forEach(e => { states.get(e.target).visible = e.isIntersecting && e.intersectionRatio >= .1; });
    sync();
   }, { threshold: [0, .1] });
   videos.forEach(v => {
    const media = v.closest('.sl-studio-gesture-media');
    const s = {v, visible:false, active:false, pending:false, blocked:false, token:0,
     resilient:v.hasAttribute('data-sl-resilient-video'), poster:media?.querySelector('.sl-studio-video-poster'),
     retry:null, frameId:null, lastTime:-1, lastProgress:performance.now(), reloads:0};
    states.set(v, s);
    v.muted = true; v.defaultMuted = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    if (media) {
     const retry = document.createElement('button');
     retry.type = 'button'; retry.className = 'sl-studio-video-retry'; retry.hidden = true;
     retry.textContent = button.dataset.slPlay;
     retry.setAttribute('aria-label', button.dataset.slPlay + ' · ' + (v.getAttribute('aria-label') || ''));
     media.append(retry); s.retry = retry;
     listen(retry, 'click', () => {
      paused = false; explicit = true;
      reset(s); start(s); label();
     });
    }
    listen(v, 'loadedmetadata', sync);
    listen(v, 'canplay', sync);
    listen(v, 'playing', () => {
     if (!wanted(s)) { v.pause(); return; }
     if (!s.resilient) { s.blocked = false; if(s.retry) s.retry.hidden = true; }
     watchFrame(s); label();
    });
    listen(v, 'timeupdate', () => {
     // Older Safari: reveal only once the playhead has advanced with decoded data.
     if (s.resilient && !v.requestVideoFrameCallback && wanted(s) && !v.paused && v.readyState >= 2 && v.currentTime !== s.lastTime) {
      s.lastProgress = performance.now(); s.lastTime = v.currentTime;
      s.blocked = false; if(s.retry) s.retry.hidden = true; poster(s, false); label();
     }
    });
    listen(v, 'error', () => block(s));
    observer.observe(v);
   });
   // Watch the affected clip only; one automatic reload, then a visible manual retry.
   const watchdog = setInterval(() => states.forEach(s => {
    if (!s.resilient || !wanted(s) || s.blocked || performance.now() - s.lastProgress < 6000) return;
    if (s.reloads < 1) { s.reloads++; reset(s); start(s); }
    else block(s);
   }), 1000);
   listen(button, 'click', () => {
    if (stop() || [...states.values()].some(s => s.blocked)) {
     paused = false; explicit = true;
     states.forEach(s => { if (s.blocked || s.v.error) reset(s); });
    } else paused = true;
    sync();
   });
   listen(document, 'visibilitychange', sync);
   listen(window, 'pageshow', sync);
   listen(window, 'pagehide', () => states.forEach(s => { s.active = false; s.token++; s.pending = false; s.v.pause(); cancelFrame(s); }));
   listen(reduced, 'change', sync);
   label();
   section.addEventListener('shopify:section:unload', () => {
    disposed = true; observer.disconnect(); clearInterval(watchdog);
    listeners.forEach(remove => remove());
    states.forEach(s => { s.token++; s.v.pause(); cancelFrame(s); if(s.retry) s.retry.remove(); });
    delete section.dataset.slReady;
   }, {once:true});
  });
 }
 init();
 document.addEventListener('shopify:section:load', event => init(event.target));
})();